export default __webpack_public_path__ + "static/media/hero.1701fe19.mp4";